import type {
  AllowedAccountData,
  CreateProviderPayload,
  EditProviderPayload,
  ProviderData,
  ProviderDataAllowedAccount,
} from '@openx/types/provider';
import { exportTypes, providerFields } from '../constants';
import type { FiletredAllowedAccounts, ProviderFormState } from '../types';

export const filterSelectedExportTypes = (exportTypes: ProviderFormState['allowed_export_types']) => {
  const filtered = Object.entries(exportTypes)
    .filter(([, value]) => value)
    .map(([key]) => key);

  return filtered;
};

export const filterAllowedAccounts = (
  providerId: string,
  initialAllowedAccounts?: ProviderDataAllowedAccount[],
  updatedAllowedAccounts?: ProviderDataAllowedAccount[]
): FiletredAllowedAccounts => {
  const initialAccountsIds = initialAllowedAccounts?.map(el => el.id);
  const updatedAccountsIds = updatedAllowedAccounts?.map(el => el.id);

  const accountsToLink = updatedAllowedAccounts?.reduce((filteredAccounts: AllowedAccountData[], account) => {
    if (!initialAccountsIds?.includes(account.id)) {
      filteredAccounts.push({ account_id: account.id, provider_id: providerId });
    }

    return filteredAccounts;
  }, []);

  const accountsToUnlink = initialAllowedAccounts?.reduce((filteredAccounts: AllowedAccountData[], account) => {
    if (!updatedAccountsIds?.includes(account.id)) {
      filteredAccounts.push({ account_id: account.id, provider_id: providerId });
    }

    return filteredAccounts;
  }, []);

  return { accountsToLink, accountsToUnlink };
};

export const transformCreateFormDataToApiPayload = (formData: ProviderFormState): CreateProviderPayload => {
  const filteredExportTypes = filterSelectedExportTypes(formData.allowed_export_types);

  return {
    object: {
      allowed_export_types: filteredExportTypes,
      name: formData.name,
      id: formData.id,
    },
  };
};

export const transformEditFormDataToApiPayload = (formData: ProviderFormState): EditProviderPayload => {
  const filteredExportTypes = filterSelectedExportTypes(formData.allowed_export_types);

  return {
    data: {
      allowed_export_types: filteredExportTypes,
      name: formData.name,
    },
    id: formData.id,
  };
};

export const transformDataToMatchProviderForm = (providerData: ProviderData): ProviderFormState => {
  const accounts = providerData.allowed_accounts.map(({ account }) => account);

  const allowedExportTypes = providerData.allowed_export_types.reduce(
    (acc: Record<string, boolean>, type: string) => {
      acc[type] = true;
      return acc;
    },
    {
      [exportTypes.OA_MATCH]: false,
      [exportTypes.BIDSTREAM]: false,
      [exportTypes.BIDSTREAM_PLUS]: false,
    }
  );

  return {
    [providerFields.ID]: providerData.id,
    [providerFields.NAME]: providerData.name,
    [providerFields.ALLOWED_EXPORT_TYPES]: allowedExportTypes,
    [providerFields.ALLOWED_ACCOUNTS]: accounts,
  };
};
